import config from '../../../client-config.js';

/**
 * Adds the shoppable video embed script (which defines <bam-playlist>) to the
 * page, unless it is already there. A local embed dev server serves it from the
 * root rather than from the default customization path.
 */
export const ensureEmbedScript = () => {
  const embedScriptSrc = process.env.EMBED_BASE_URL
    ? `${config.embedBaseUrl}/embed.js`
    : `${config.embedBaseUrl}/default/embed.js`;
  if (document.querySelector(`script[src="${embedScriptSrc}"]`)) return;

  const script = document.createElement('script');
  script.src = embedScriptSrc;
  script.async = true;
  document.body.appendChild(script);
};
